import {SOPostSimpleAttributePermission} from '../../core/simple-attribute-permission/so-post-simple-attribute-permission';
import {SimpleAttributePermissionCore} from './simple-attribute-permission.core';
import {SOGetSimpleAttributePermission} from '../../core/simple-attribute-permission/so-get-simple-attribute-permission';
import {FormField, SelectionOption} from 'lionheartland';
import {postSimpleAttributePermissionFormFieldOptions} from './post-simple-attribute-permission-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {SimpleAttributeCore} from '../simple-attribute/simple-attribute.core';
import {SOGetSimpleAttribute} from '../../core/simple-attribute/so-get-simple-attribute';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostSimpleAttributePermission extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postSimpleAttributePermissionFormFieldOptions);

  RequestClass = SOPostSimpleAttributePermission

  constructor(
    public entityCore: SimpleAttributePermissionCore
  ) {
    super();
    if (postSimpleAttributePermissionFormFieldOptions.simpleAttribute) {
      postSimpleAttributePermissionFormFieldOptions.simpleAttribute.makeCore = true;
    }
    if (postSimpleAttributePermissionFormFieldOptions.project) {
      postSimpleAttributePermissionFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('whiteList'),
      this.getFormValueFromIdentifier('permissionType'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier(
        'simpleAttribute',
        SOGetSimpleAttribute,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}